export const LocalStateStore = {
  mounted() {
    this.handleEvent("session-store", (obj) => this.store(obj));
    this.handleEvent("session-clear", (obj) => this.clear(obj));
  },

  store(obj) {
    sessionStorage.setItem(obj.key, JSON.stringify(obj.data));
  },

  clear(obj) {
    sessionStorage.removeItem(obj.key);
  },
};

// Sent with every LiveView join so `RememberFilters` can restore a page's
// filters before its first load, instead of after a round trip.
export const rememberedFilters = () =>
  Object.fromEntries(
    Object.keys(sessionStorage)
      .filter((key) => key.endsWith("-filters"))
      .map((key) => [key, JSON.parse(sessionStorage.getItem(key))]),
  );
